import { useEnv } from './useEnv'
/**
 *  移植相关配置
 * */

export interface PortingConfigItem {
  isI18n?: boolean //是否国际化
  title: string
  favicon: string
  logo: string
  watermarkColor?: string //水印颜色
  loginShowLogo?: boolean //是否登录页显示logo
  isOnlyEvalution?: boolean //是否只测评 只是测评的话 登陆后不需要请求获取面试个数、考试个数、阅卷个数的接口
  lognWidth?: number
  redirectPath?: string
  paperHiddenField?: string[] //活动列表隐藏字段
  isInformationFirst?: boolean //是否优先显示个人信息  开启后 用户登录 如果有个人信息填写  则直接显示个人信息填写界面
  isInnerPersonDisabledInfo?: boolean //是否内部人员个人信息只填写不能编辑
  baomingField?: string[] //报名表单字段
  browserFingerprintFlag?: boolean //请求头是否需要指纹
  disabledFields: string[] // 禁用信息
  isBatchAnswer?: boolean //是否批量答题
  isShowStaffCode?: boolean //是否显示被评价编码
  loginTabs?: ('account' | 'mobile' | 'idCard')[] //登录页tabs
  isPolicyAgreement?: boolean //是否显示隐私政策
  layoutBtns?: ('history' | 'changePw' | 'logout')[] //布局按钮
  isBugs?: boolean //是否显示反馈按钮
}

export function usePortingConfig() {
  const config: Record<string, PortingConfigItem> = {
    zhxm: {
      isI18n: false,
      loginShowLogo: false,
      isInformationFirst: true,
      watermarkColor: '#F2F3F5',
      logo: 'logo',
      favicon: '',
      title: '潜在运行人员岗位胜任素质测评系统',
      lognWidth: 300, //这里声明的宽度 需要自己取定义下 例如 w-300  要手动写下这个样式  不然打包的时候可能会没有这个样式导致问题
      redirectPath: '/login',
      baomingField: ['name', 'phone', 'idCard', 'staffCode', 'email', 'schoolName'],
      paperHiddenField: ['totalNum', 'startDateTime', 'endDateTime'],
      browserFingerprintFlag: false,
      disabledFields: []
    },
    tjrc: {
      isI18n: false,
      loginShowLogo: true,
      isInformationFirst: true,
      watermarkColor: '#F2F3F5',
      logo: 'tjrc',
      favicon: '',
      title: '北方测评',
      lognWidth: 300, //这里声明的宽度 需要自己取定义下 例如 w-300  要手动写下这个样式  不然打包的时候可能会没有这个样式导致问题
      redirectPath: '/login',
      paperHiddenField: ['totalNum', 'startDateTime', 'endDateTime'],
      disabledFields: [],
      loginTabs: ['account'],
      isPolicyAgreement: false,
      layoutBtns: ['changePw', 'logout'],
      isBugs: false
    },
    nhxm: {
      lognWidth: 228,
      redirectPath: '/activity/evaluation',
      isInformationFirst: false,
      isI18n: false,
      logo: 'logo',
      favicon: '',
      watermarkColor: '#ccc',
      loginShowLogo: true,
      title: '人才评价云',
      paperHiddenField: [],
      baomingField: ['name', 'phone', 'idCard', 'staffCode', 'email', 'schoolName'],
      isInnerPersonDisabledInfo: true,
      browserFingerprintFlag: true,
      disabledFields: ['staffCode'],
      isShowStaffCode: true,
      isBatchAnswer: true
    },
    etest: {
      lognWidth: 228,
      redirectPath: '/activity/evaluation',
      isInformationFirst: false,
      isI18n: false,
      logo: 'logo',
      favicon: '',
      watermarkColor: '#ccc',
      loginShowLogo: true,
      title: '人才评价云',
      paperHiddenField: [],
      baomingField: ['name', 'phone', 'idCard', 'staffCode', 'email', 'schoolName'],
      isInnerPersonDisabledInfo: true,
      browserFingerprintFlag: true,
      disabledFields: ['staffCode']
    },
    epro: {
      lognWidth: 228,
      redirectPath: '/activity/evaluation',
      isInformationFirst: false,
      isI18n: false,
      logo: 'logo',
      favicon: '',
      watermarkColor: '#ccc',
      loginShowLogo: true,
      title: '人才评价云',
      paperHiddenField: [],
      baomingField: ['name', 'phone', 'idCard', 'staffCode', 'email', 'schoolName'],
      isInnerPersonDisabledInfo: true,
      browserFingerprintFlag: true,
      disabledFields: ['staffCode']
    },
    platform: {
      isI18n: true,
      logo: 'logo',
      loginShowLogo: true,
      watermarkColor: '#F2F3F5',
      favicon: '/nm.png',
      title: '人才评价云',
      lognWidth: 228,
      redirectPath: '/login',
      isInformationFirst: true,
      paperHiddenField: [],
      baomingField: ['name', 'phone', 'idCard', 'email', 'schoolName'],
      browserFingerprintFlag: false,
      disabledFields: [],
      isShowStaffCode: false,
      isBatchAnswer: true,
      loginTabs: ['account', 'mobile', 'idCard'],
      isPolicyAgreement: true,
      layoutBtns: ['history', 'changePw', 'logout'],
      isBugs: true
    }
  }

  const { projectName } = useEnv()

  const portingConfig = config[projectName]
  return { portingConfig, projectName }
}
